import { BackstageOverrides } from '@backstage/core-components';
import { Theme } from '@mui/material/styles';
import { getThemeTokens } from '../tokens';

export const styledBackstageContentHeader = (
  theme: Theme,
): BackstageOverrides['BackstageContentHeader'] => {
  const tokens = getThemeTokens(theme);

  return {
    container: {
      alignItems: 'center',
      gap: theme.spacing(1.5),
      marginBottom: theme.spacing(2),
      paddingBottom: theme.spacing(0.5),
    },
    leftItemsBox: {
      gap: theme.spacing(1.25),
    },
    rightItemsBox: {
      gap: theme.spacing(1),
    },
    description: {
      color: tokens.textMuted,
      fontSize: theme.typography.body2.fontSize,
    },
    title: {
      color: tokens.textPrimary,
      fontSize: theme.typography.subtitle1.fontSize,
      fontWeight: 700,
    },
  };
};
